export const isValidPositiveNumber = (raw) => {
    const value = Number(raw);
    // Check if the value is not null, undefined, or NaN
    if (value === null || value === undefined || Number.isNaN(value)) {
        return false;
    }
    // Check if the value is a finite number
    if (!Number.isFinite(value)) {
        return false;
    }
    if (value < 0) {
        return false;
    }
    // Check if the value is within the range of Number.MIN_SAFE_INTEGER and Number.MAX_SAFE_INTEGER
    if (value < Number.MIN_SAFE_INTEGER || value > Number.MAX_SAFE_INTEGER) {
        return false;
    }
    // If the value is a string, try to parse it as a number
    if (typeof value === 'string' && Number.isNaN(+value)) {
        return false;
    }
    // If none of the above conditions are met, the value is a valid number
    return true;
};
//# sourceMappingURL=isValidPositiveNumber.js.map